/* eslint-disable */
import mapStylesFile from '../../inc/map-styles';

let key = document.querySelectorAll('[data-google-key]')[0]
const API_KEY = key.getAttribute("data-google-key")
const HOLDER_SELCTOR = '.map-block'
let holders = []

function init () {  
  holders.forEach((holder) => {
    const dataPosition = holder.getAttribute("data-position").split(', ');
    const position = { lat: +dataPosition[0], lng: +dataPosition[1] };
    const mapStyles = mapStylesFile;
    const zoomData = +holder.getAttribute("data-zoom");
    const map = new google.maps.Map(holder, {
      center: position,
      disableDefaultUI: true,
      zoom: zoomData,
      styles: mapStyles
    })
    const marker = new google.maps.Marker({ map, position: position })
  })
}

function setGoogleMapAPI () {
  window.initMap = init

  const tag = document.createElement('script');
  tag.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&callback=initMap`;
  tag.async = true;

  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

export default function initGoogleMap () {
  holders = Array.prototype.slice.call(document.querySelectorAll(HOLDER_SELCTOR))

  if (holders.length) setGoogleMapAPI()
}